import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { PermissionFragment } from 'graphql/Permission/fragments/PermissionFragment';
/**
 * @fragment MeFragment
 * @since 1.0.0
 */
export const MeFragment = gql `
  fragment MeFragment on Me {
    id
    uuid
    firstname
    lastname
    fullname
    email
    phone
    extension
    title
    notification
    createdAt
    updatedAt

    language {
      ...LanguageFragment
    }

    group {
      id
      title
      infos
      count
      tag
      updatable

      translations {
        id
        title
        infos

        language {
          ...LanguageFragment
        }
      }
    }

    contact {
      id
      title
      firstname
      lastname
      fullname
      manager
      discount

      client {
        id
        name
        discount

        locations {
          id
          name
          address
          city
        }

        image {
          ...MediaFragment
        }
      }
    }

    contacts {
      id
      firstname
      lastname

      client {
        id
        name
      }
    }

    defaultPartner {
      id
      name
      image {
        ...MediaFragment
      }
    }

    image {
      ...MediaFragment
    }

    permissions {
      ...PermissionFragment
    }

    session {
      token
      startedAt
      expiresAt
      impersonated

      user {
        id
        account {
          id
          tag
        }
      }
    }
  }

  ${LanguageFragment}
  ${MediaFragment}
  ${PermissionFragment}
`;
